<template>
    <div class="model-box ptn course-list">
        <div class="model-box__bd clear">
            <course-card v-for="(item,index) in list" :key="item.id" :course="item"></course-card>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import CourseCard from '@/components/CourseCard';
export default {
    name: 'CourseList',
    components: {
        CourseCard
    },
    data(){
      return {
        list:{},  // 团课列表
        total:0   // 总数
      }
    },
    created(){
      // if(this.$route.params.clubId){
        // 取课程列表数据
        let _this = this;
        this.$http.get('club_group_course/getList?clubId=' + this.$route.params.clubId).then(function(res){
          _this.list = res.data.value.data
          _this.total = res.data.value.total
        })
      // }else{
      //   // 返回上一个路由
      //   this.$router.go(-1)
      // }
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/CourseList.vue